import React from 'react';
import { FlexBox } from '@ardoq/layout';

export const Centered = ({
  height,
  children,
  className,
}: {
  height?: string;
  children: React.ReactNode;
  className?: string;
}) => (
  <FlexBox
    height="full"
    align="center"
    justify="center"
    style={height ? { height } : undefined}
    className={className}
  >
    {children}
  </FlexBox>
);
